import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import "vant/lib/picker/style";
import _Picker from "vant/lib/picker";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { i18n } from "@/i18n/i18n-setup";
Vue.use(_Picker);

var SelectBirthday =
/*#__PURE__*/
function (_Vue) {
  _inherits(SelectBirthday, _Vue);

  function SelectBirthday() {
    var _this;

    _classCallCheck(this, SelectBirthday);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectBirthday).apply(this, arguments));
    _this.done = i18n.t("common.button.done");
    _this.cancel = i18n.t("common.button.cancel");
    _this.monthList = [i18n.t("month_date[0]"), i18n.t("month_date[1]"), i18n.t("month_date[2]"), i18n.t("month_date[3]"), i18n.t("month_date[4]"), i18n.t("month_date[5]"), i18n.t("month_date[6]"), i18n.t("month_date[7]"), i18n.t("month_date[8]"), i18n.t("month_date[9]"), i18n.t("month_date[10]"), i18n.t("month_date[11]")];
    _this.dayListFeb = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29];
    _this.dayListSmall = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];
    _this.dayListBig = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
    _this.horoscopeList = ["Capricorn", "Aquarius", "Pisces", "Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio", "Sagittarius"];
    _this.horoscopeDateList = [19, 18, 20, 19, 20, 21, 22, 22, 22, 23, 22, 21];
    return _this;
  }

  _createClass(SelectBirthday, [{
    key: "onConfirm",
    value: function onConfirm(value, index) {
      var monthIdex = index[0];
      var day = value[1];
      var horoscopeIndex = day <= this.horoscopeDateList[monthIdex] ? monthIdex : monthIdex + 1;
      var horoscope = horoscopeIndex <= 11 ? this.horoscopeList[horoscopeIndex] : this.horoscopeList[0];
      var month = monthIdex + 1;
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      var birthday = month + "-" + day;
      this.$emit("showBirthdayMask", {
        isShow: false,
        birthdayStr: birthday,
        birthdayMonth: monthIdex + 1,
        birthdayDay: value[1],
        horoScopeName: horoscope
      });
    }
  }, {
    key: "closeMask",
    value: function closeMask() {
      this.$emit("showBirthdayMask", {
        isShow: false
      });
    }
  }, {
    key: "onChange",
    value: function onChange(picker, values) {
      if (values[0] === i18n.t("month_date")[1]) {
        picker.setColumnValues(1, this.dayListFeb);
        values[1] <= 28 ? picker.setColumnIndex(1, values[1] - 1) : picker.setColumnIndex(1, 28);
      } else if (values[0] === i18n.t("month_date")[3] || values[0] === i18n.t("month_date")[5] || values[0] === i18n.t("month_date")[8] || values[0] === i18n.t("month_date")[10]) {
        picker.setColumnValues(1, this.dayListSmall);
        values[1] <= 29 ? picker.setColumnIndex(1, values[1] - 1) : picker.setColumnIndex(1, 29);
      } else {
        picker.setColumnValues(1, this.dayListBig);
        picker.setColumnIndex(1, values[1] - 1);
      }
    }
  }, {
    key: "columns",
    get: function get() {
      return [{
        values: this.monthList,
        className: "column1",
        defaultIndex: this.birthdayMonth - 1
      }, {
        values: this.dayListBig,
        className: "column2",
        defaultIndex: this.birthdayDay - 1
      }];
    }
  }]);

  return SelectBirthday;
}(Vue);

tslib_1.__decorate([Prop({
  default: 0
})], SelectBirthday.prototype, "birthdayMonth", void 0);

tslib_1.__decorate([Prop({
  default: 0
})], SelectBirthday.prototype, "birthdayDay", void 0);

SelectBirthday = tslib_1.__decorate([Component({
  components: {}
})], SelectBirthday);
export default SelectBirthday;